module.exports = __webpack_public_path__ + "img/level2addon_idle_mask.873088f2.png";